// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatEmptyStateGreeting-moduleavatar__o5dGv IconNG-moduleiconContainer__SxWZ0";
var _2 = "GretaAIChatEmptyStateGreeting-moduleheading__hbwzi";
var _3 = "GretaAIChatEmptyStateGreeting-modulesubtitle__w54bY";
export { _1 as "avatar", _2 as "heading", _3 as "subtitle" }
